module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Virginia Woolf\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v(" Virginia Woolf (1882–1941), an English modernist, has been heralded as one of the greatest female writers of all time. In 1915, she published her first novel, "), _c('I', [_vm._v("The Voyage Out")]), _vm._v(", which became known for its peculiar narrative perspectives and free-association prose. She followed this up with several famous novels such as "), _c('I', [_vm._v("Mrs. Dalloway")]), _vm._v(" and"), _c('I', [_vm._v(" Jacob’s Room")]), _vm._v(", as well as the feminist essay "), _c('I', [_vm._v("A Room of One’s Own")]), _vm._v(". Woolf suffered from depression and committed suicide in 1941. ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/TPnXZQ/tc-custom/9781504078511.jpg?1738494814849",
      "alt": "This image is the cover for the book Jacob's Room"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Jacob's Room\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_c('b', [_vm._v("This pioneering novel explores a young man’s journey from boyhood to the warfront by the author of "), _c('i', [_vm._v("Mrs. Dalloway ")]), _vm._v("and "), _c('i', [_vm._v("To the Lighthouse.")])])]), _c('p', [_vm._v("Jacob Flanders is a young man typical of his generation—like so many who would go on to face death in the battlefields of the Great War. In this probing, elegiac book, his life is recounted through the private memories and sentiments of those who knew him. We meet Jacob as the boy who preoccupies his mother’s thoughts; the young man at Cambridge as he was known to his schoolmates; and the bachelor about London as seen through the eyes of those he loved.")]), _vm._v(" From boyhood to college, from London to the Continent, and from peacetime to war, Jacob’s is a life composed of impressions. First published in 1922, "), _c('i', [_vm._v("Jacob’s Room")]), _vm._v(" represents a stylistic departure from Virginia Woolf’s previous novels and a watershed in the development of modernist literature.\n    "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Open Road Media\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5610da35","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0